import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../../global/util/Constant';
import {DocumentService} from '../../../service/document.service';
import {InformType} from '../../../../global/util/enum/InformType';

@Component({
  selector: 'app-show-copy-url',
  templateUrl: './show-copy-url.component.html',
  styleUrls: ['./show-copy-url.component.css']
})
export class ShowCopyUrlComponent implements OnInit {
  title: string;
  people: any[] = [];
  peopleInvited: any[] = [];
  urlSignOperator: any;
  loadingCopyClipboard: boolean;
  documentSelected: any;

  constructor(private activeModal: NgbActiveModal,
              private documentService: DocumentService) {
  }

  ngOnInit(): void {
  }

  accept() {
    this.activeModal.close();
  }

  public isOperationComplete(person: any) {
    return Constant.COMPLETED === person._more.operationCompleted;
  }

  copyToClipboard(person: any) {
    this.loadingCopyClipboard = true;
    const url = Constant.ROOT_API_V1.concat('/documents/copy-url?').concat('documentId=').concat(this.documentSelected.id).concat('&personId=').concat(person.id);
    this.documentService.get(url).subscribe((copy: any) => {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = copy.url;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      setTimeout(() => {
        this.loadingCopyClipboard = false;
        this.activeModal.close();
      }, 300);
    }, error => {
      this.activeModal.close(InformType.Danger);
    });
  }
}
